import { uniq, cloneDeep } from 'lodash';

const getIdFromDNDId = dndId => {
  const strId = dndId.split('-').pop();

  return strId.toLowerCase() === 'null' ? null : Number(strId);
};

const getSortOrders = entities => entities.map(e => e.sortOrder);

const updateSortOrdersToArrayOrder = (entities, startWith = 0) =>
  entities.map((e, i) => {
    e.sortOrder = i + startWith;
    return e;
  });

const ensureSequentialOrder = (entities, startWith = 0) => {
  entities.sort((e1, e2) => e1.sortOrder - e2.sortOrder);
  let latestOrder = startWith;
  return entities.map(e => {
    e.sortOrder = latestOrder;
    latestOrder += 1;
    return e;
  });
};

function reorder<T>(list: T[], startIndex: number, endIndex: number) {
  const result = cloneDeep(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}

const isSequentialOrderCorrect = (entities, startWith = 0) => {
  const sortOrders = getSortOrders(entities);
  return sortOrders.every((o, i) => o === i + startWith);
};

const hasDuplicateSortOrders = entities => {
  const sortOrders = getSortOrders(entities);
  return sortOrders.length !== uniq(sortOrders).length;
};

const isOrderBroken = (entities, startWith = 0) =>
  hasDuplicateSortOrders(entities) ||
  !isSequentialOrderCorrect(entities, startWith);

export {
  ensureSequentialOrder,
  isSequentialOrderCorrect,
  hasDuplicateSortOrders,
  isOrderBroken,
  updateSortOrdersToArrayOrder,
  reorder,
  getIdFromDNDId,
};
